import { veeduria_url, download_pdf_url } from "./urlBase"
import { apiCall, apiPdf } from "./apiCall";

const insertar_veeduria = async (data) => {

    try {

        // const token = localStorage.getItem('token')
        // const request = client(token)
        // const resp = await request.call( 'POST', veeduria_url, data )

        const resp = await apiCall( 'POST', veeduria_url, data )
        const response = resp.data

        if ( response.Success ) {
            return response
        }
        else {
            console.log('veeduriaHelper', '15')
            throw response
        }

    } catch ( e ) {
        console.log('veeduriaHelper', '20')
        throw e
    }
}

const download_constancia = async (id) => {

    try {

    //     const response = await fetch(`${download_pdf_url}/${id}`, {
    //     method: 'GET',
    //     headers: {
    //       'Content-Type': 'application/json', // Si es necesario
    //     },
    //   });

    //   if (!response.ok) {
    //     throw new Error('Error al descargar el archivo PDF');
    //   }

    //   // Convertimos la respuesta a un blob
    //   const blob = await response.blob();
    //   // Creamos un objeto URL del blob
    //   const blobUrl = URL.createObjectURL(blob);

    //   // Creamos un enlace invisible
    //   const link = document.createElement('a');
    //   link.href = blobUrl;
    //   link.setAttribute('download', 'archivo.pdf');
    //   document.body.appendChild(link);
      
    //   // Simulamos el clic en el enlace para iniciar la descarga
    //   link.click();

    //   // Eliminamos el enlace después de la descarga
    //   link.parentNode.removeChild(link);




        const resp = await apiPdf( 'GET', `${download_pdf_url}/${id}`, null )
        debugger;
        if (!resp.statusText == 'OK') {
            throw new Error('Error al descargar el archivo PDF');
        }

        // Convertimos la respuesta a un blob
        const blob = new Blob([resp.data], { type: 'application/pdf' });
        // Creamos un objeto URL del blob
        const blobUrl = URL.createObjectURL(blob);

        // Creamos un enlace invisible
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'constancia.pdf');
        document.body.appendChild(link);
        
        // Simulamos el clic en el enlace para iniciar la descarga
        link.click();

        // Eliminamos el enlace después de la descarga
        link.parentNode.removeChild(link);






// console.log('download_constancia::', id)
//         // const token = localStorage.getItem('token')
//         // const request = client(token)
//         // const resp = await request.call( 'POST', veeduria_url, data )

//         debugger;
//         const resp = await apiPdf( 'GET', `${download_pdf_url}/${id}`, null )
//         const response = resp.data

//         // Creamos un blob con la respuesta recibida
//         const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
//         // Creamos una URL del objeto blob
//         const pdfUrl = URL.createObjectURL(pdfBlob);

//         // Ahora puedes usar pdfUrl para abrir el archivo PDF en una nueva ventana o descargarlo automáticamente
//         window.open(pdfUrl);

        return 1;

    } catch ( e ) {
        console.log('veeduriaHelper', '20')
        return 0;
    }
}


export {
    insertar_veeduria,
    download_constancia
}